export default "/images/vendor/flag-icon-css/flags/1x1/td.svg?ad4b4469031fb72bd98f795c031cfeee";